import React from "react";

function GraphicWrapper( { children, className } )
{
  return (
    <div className={`graphicWrapper ${className}`}>
      { children }
    </div>

  )
}

export default GraphicWrapper;
